module.exports = __webpack_public_path__ + "static/media/997033.b1662f74.png";